import { useMutation } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useGetAdminDashboard() {
  return useMutation({
    mutationFn: ({ filter }) => {
      const params = new URLSearchParams();
      if (filter) {
        params.append("filter", filter);
      }
      return apiClient({
        url: `admin/dashboard?${params.toString()}`,
        method: "GET"
      });
    }
  });
}




















